<template>
    <wizard-layout :id="this.step">
        <template>
            <wizard-box-left>
                <wizard-step :step="this.step" :header_step="this.header_step" :user="this.user"></wizard-step>

                <wizard-header :title="this.title"></wizard-header>

                <div class="row">
                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Indirizzo*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" type="text" v-model="address" placeholder="Via Europa" @click="inputsAreTyped()" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Numero*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" type="number" v-model="number" placeholder="30" @click="inputsAreTyped()" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Città*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" type="text" v-model="city" placeholder="Bologna" @click="inputsAreTyped()" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>CAP*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" type="text" v-model="zip" placeholder="40127" @click="inputsAreTyped()" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Paese*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" type="text" v-model="country" placeholder="Italia" @click="inputsAreTyped()" />
                            </div>
                        </div>
                    </div>
                </div>

                <wizard-footer :step="this.step"
                               :display_next_button="display_next_button"
                               :wizard_data="getWizardData"
                               :user="this.user"
                               :inputs_are_changed="inputs_are_changed"
                               @refresh-address="refreshAddress"
                >
                </wizard-footer>
            </wizard-box-left>
            <wizard-box-right :id="this.step">
                <div class="wizard-map">
                    <GmapMap
                            :center="getPosition()"
                            :zoom="19"
                            style="width: 100%; height: 100%; border: 0;"
                    >
                        <GmapMarker
                                :position="getPosition()"
                                :clickable="true"
                                :draggable="true"
                                @click="center=getPosition()"
                        />
                    </GmapMap>
                </div>
            </wizard-box-right>
        </template>
    </wizard-layout>
</template>


<script>
import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardHeader from "@/Pages/Wizard/Elements/WizardHeader";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import {getParameterByName, redirectWizardSteps} from "@/helpers/helper";

export default {
    props: ['can', 'data', 'user'],

    components: {WizardBoxLeft, WizardLayout, WizardBoxRight, WizardStep, WizardHeader, WizardFooter},

    computed: {
        display_next_button() {
            return this.fieldsAreEmpty()
        },

        getWizardData() {
            return {
                address: this.address,
                municipality: this.city,
                house_number: this.number,
                country: this.country,
                postal_code: this.zip,
                inserted_by: this.inserted_by,
                agency_id: this.agency_id
            }
        }
    },

    data() {
        let current_property = JSON.parse(localStorage.getItem('current_property'))
        return {
            city: current_property ? current_property.municipality : '',
            address: current_property ? current_property.address : '',
            number: current_property ? current_property.house_number : '',
            zip: current_property ? current_property.postal_code : '',
            country: current_property ? current_property.country : '',
            step: 1,
            header_step: 2,
            title: "Conferma il tuo indirizzo",
            lat: '',
            lng: '',
            inserted_by: this.can.admin ? 'cashouse' : this.isAgency() ? 'agency' : 'customer',
            agency_id: this.user ? this.user.agency_id : null,
            inputs_are_changed: false
        }
    },

    methods: {
        inputsAreTyped() {
            this.inputs_are_changed = true
        },

        isAgency() {
            return (this.user !== null && !(window.location.href.includes('customer')))
        },

        getPosition() {
            return {
                lat: parseFloat(this.lat),
                lng: parseFloat(this.lng)
            }
        },

        getAddress() {
            if (getParameterByName('address') !== '' && getParameterByName('address') !== null) {
                var address = getParameterByName('address')
            } else if (this.fieldsAreEmpty()) {
                var address = this.number + '+' + this.address + '+' + this.city + '+' + this.zip + '+' + this.country
            } else {
                return
            }

            this.handleRequest(address)
        },

        refreshAddress() {
            var self = this;
            let address = this.number + '+' + this.address + '+' + this.city + '+' + this.zip + '+' + this.country

            self.handleRequest(address);

            this.inputs_are_changed = false
        },

        handleRequest(address) {
            let url = process.env.MIX_APP_GOOGLE_MAPS_ENDPOINT + '?address=' + address + '&key=' + process.env.MIX_APP_GOOGLE_MAPS_API_KEY
            axios.get(url)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.results.length > 0) {
                            var address_components = response.data.results[0].address_components
                            var address = address_components.filter(component => {
                                if (component.types.includes('route')) {
                                    return component
                                }
                            })

                            if (address.length > 0) {
                                this.address = address[0].short_name
                            } else {
                                this.address = ''
                            }

                            var city = address_components.filter(component => {
                                if (component.types.includes('locality')) {
                                    return component
                                }
                            })

                            if (city.length > 0) {
                                this.city = city[0].short_name
                            } else {
                                this.city = ''
                            }

                            var country = address_components.filter(component => {
                                if (component.types.includes('country')) {
                                    return component
                                }
                            })

                            if (country.length > 0) {
                                this.country = country[0].short_name
                            } else {
                                this.country = ''
                            }

                            var zip = address_components.filter(component => {
                                if (component.types.includes('postal_code')) {
                                    return component
                                }
                            })

                            if (zip.length > 0) {
                                this.zip = zip[0].short_name
                            } else {
                                this.zip = ''
                            }

                            var number = address_components.filter(component => {
                                if (component.types.includes('street_number')) {
                                    return component
                                }
                            })

                            if (number.length > 0) {
                                this.number = number[0].short_name
                            } else {
                                this.number = ''
                            }

                            var geometry = response.data.results[0].geometry

                            this.lat = geometry.location.lat
                            this.lng = geometry.location.lng
                        } else {
                            this.$toast.error('Address is not correct')
                        }
                    } else {
                        this.$toast.error('Address is not correct')
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        emptyFields() {
            this.address = this.city = this.zip = this.country = this.number = "";
        },

        fieldsAreEmpty() {
            return (this.city !== '' && this.address !== '' && this.zip !== '' && this.country !== '' && this.number !== '')
        }
    },

    beforeMount() {
        redirectWizardSteps(this.isAgency(), this.step, 'test', this.$inertia)

        this.getAddress();
    }
}
</script>
